import { IdentityProviderLogo } from '@features/login/identity-provider';
import { Model } from 'miragejs';
import { ModelDefinition } from 'miragejs/-types';

export interface Authorization {
  maxInactiveInterval: number;
  email: string;
  fullName: string;
  authorities: string[];
}

export const AuthorizationModel: ModelDefinition<Authorization> = Model.extend({});

export interface IdentityProvider {
  logo: IdentityProviderLogo | undefined;
}

export const IdentityProviderModel: ModelDefinition<IdentityProvider> = Model.extend({});
